import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

const routerView = {
  render(c) {
    return c("router-view");
  }
}
export default [
  {
    path: 'bookings',
    name: ROUTES.TAXI.BOOKING_LIST,
    meta: {
      breadcrumb: i18n.tc('breadcrumbs.Booking'),
      activeKey: 'taxi.booking.list'
    },
    component: routerView,
    children: [
      {
        path: '',
        name: ROUTES.TAXI.BOOKING_LIST,
        meta: {
          activeKey: 'taxi.booking.list'
        },
        component: () => import("@components/taxi/bookings/ListBooking"),
      },
      {
        path: ':id/edit',
        name: ROUTES.TAXI.BOOKING_EDIT,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking edit'), activeKey: 'taxi.booking.list'},
        component: () => import("@components/taxi/bookings/BookingEdit"),
      },
      {
        path: 'history/:id',
        name: ROUTES.TAXI.BOOKING_HISTORY_LIST,
        meta: {breadcrumb: i18n.tc('breadcrumbs.Booking history'), activeKey: 'taxi.booking.list'},
        component: () => import("@components/taxi/bookings/ListBookingHistory"),
      },
    ]
  },
];
